import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { classes, Root } from './utils';
import uploadFile from '../../../../assets/uploadFile-assets/uploadFile.png';
import { completeNotification } from '../../../../store/socketSlice';
import Toast from '../../utils/Toast';
import { theme } from '../../../../theme';
import { INVOICE, UPLOAD } from '../../../../constants/staticContent';

import UploadDocument from './UploadDocument';

const UploadFile = ({ setEnterPressed, setUploadPending, documentType }) => {
  const dispatch = useDispatch();

  const notifyUser = useSelector((state) => state.socket.notification);
  const notificationMessage = notifyUser.message;
  useEffect(() => {
    if (notifyUser && notifyUser.status === 'Completed') {
      Toast({ message: `${notificationMessage}`, variant: 'success' });
      dispatch(completeNotification({}));
    }
  }, [notifyUser]);

  return (
    <Root className={classes.root}>
      <Box className={classes.centerContent}>
        <img src={uploadFile} alt="uploadFile" className={classes.uploadFile} />

        <Typography variant="h4" color={theme.palette.darkPurple.main}>
          Drag and drop all documents here
        </Typography>

        <Box className={classes.paragraphTextBox}>
          <Typography variant="subtitle1">
            {INVOICE.FILE_FORMATE_MESSAGE}
          </Typography>
        </Box>

        <Box>
          <UploadDocument
            uploadButtonTypo={UPLOAD.CHOOSE_FILES}
            setEnterPressed={setEnterPressed}
            setUploadPending={setUploadPending}
            documentType={documentType}
          />
        </Box>
      </Box>
    </Root>
  );
};

UploadFile.defaultProps = {
  setEnterPressed: null,
};

UploadFile.propTypes = {
  setEnterPressed: PropTypes.func,
  setUploadPending: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
};
export default UploadFile;
